import { RefObject } from 'react';

const MAIN_HEADER_SELECTOR = '[class*="header-navigation_header-navigation"]';

export const getScrollTargetWithHeader = (bodyRef: RefObject<HTMLElement>) => {
    const element = bodyRef.current;
    if (!element) return null;

    const header = document.querySelector(MAIN_HEADER_SELECTOR);

    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const rect = element.getBoundingClientRect();
    const isHiddenByHeader = rect.top < headerHeight;
    const isAboveViewport = rect.top < 0;

    if (isHiddenByHeader || isAboveViewport) {
        const scrollTarget = window.pageYOffset + rect.top - headerHeight - 16; // 16px buffer
        return scrollTarget;
    }

    return null;
};
